import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import classes from "./PrintRecipt.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import api, { BASE_URL } from "../../Components/API/Api";
import {
  BarChart2,
  Filter,
  CalendarClock,
  Mail,
  ArrowLeft,
  Printer,
  Download,
  Settings,
} from "lucide-react";

const PrintRecipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { total, invoice, responseData } = location.state || {};
  const [companyInfo, setCompanyInfo] = useState(null);
  const componentRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Receipt",
    copyStyles: true,
    pageStyle: `
      @page { margin: 12mm; size: auto; }
      html, body { height: auto !important; background: #ffffff !important; margin: 0; padding: 0; }
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      #invoice-print-root { display: block !important; visibility: visible !important; position: relative !important; width: 100% !important; min-height: 100vh !important; background: #fff !important; color: #333 !important; padding: 12mm !important; }
      #invoice-print-root * { visibility: visible !important; }
    `,
  });

  // Fetch company info from API
  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await api.get(`/v1/companies/get-info`);

        if (response?.data?.status && response?.data?.data?.length > 0) {
          setCompanyInfo(response.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching company info:", error);
      }
    };

    fetchCompanyInfo();
  }, []);

  // Use API company info, fallback to responseData/invoice company, then empty object
  const company = companyInfo || responseData?.company || invoice?.company || {};
  console.log(invoice);

  const vat = total * 0.075;
  const discount = 0;
  const grandTotal = total + vat - discount;

  const amountPaid = Number(
    responseData?.amount_paid ||
    invoice?.amount_paid ||
    invoice?.total_amount_paid ||
    0
  );

  const getBackendDescription = (value, fallback = "") => {
    const candidates = [
      value?.description,
      value?.message,
      value?.data?.message,
      value?.item_description,
      value?.item?.description,
      value?.item_name,
      value?.name,
      value?.product_name,
      value?.product?.name,
      value?.item?.name,
      value?.sales_description,
      fallback,
    ];

    return candidates.find((candidate) => {
      if (candidate === undefined || candidate === null) return false;
      return String(candidate).trim() !== "";
    }) || "";
  };

  const receiptDescription =
    getBackendDescription(invoice, responseData?.description) ||
    getBackendDescription(responseData, invoice?.description) ||
    "—";

  const isPaid =
    amountPaid >= grandTotal ||
    (invoice?.status || "").toLowerCase() === "paid" ||
    (invoice?.payment_status || "").toLowerCase() === "paid";

  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };

  if (!location.state) {
    return (
      <div className={classes.errorPage}>
        <h2>Invoice data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  const printInvoice = () => {
    if (handlePrint) {
      handlePrint();
    }
  };

  function toTitleCase(str) {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <div>
      <div className={classes.noPrint}>
        <HeaderNav activePage={pageMap[location.pathname]} />
      </div>
      <div className={classes.Container}>
        {/* Action Buttons */}
        <div className={`${classes.actions} ${classes.noPrint}`}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>
        <div className={`${classes.act} ${classes.noPrint}`}>
          <form className={classes.form}>
            <div className={classes.group}>
              <label>Period:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>Current month</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Group by:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>None</option>
                  <option>Cash</option>
                  <option>Cheque</option>
                  <option>Transfer</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>Start Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <label>End Date:</label>
              <div className={classes.dropdownWrapper}>
                <select className={classes.statusDropdown}>
                  <option>30/02/25</option>
                  <option>12/07/25</option>
                  <option>03/04/25</option>
                  <option>27/01/25</option>
                </select>
                <span className={classes.arrowDown}>▼</span>
              </div>
            </div>
            <div className={classes.group1}>
              <button className={classes.greenBtn}>
                <BarChart2 size={16} style={{ marginRight: "6px" }} />
                Run Report
              </button>
            </div>
          </form>

          <div className={classes.iconbars}>
            <div className={classes.iconbarr}>
              <div className={classes.iconbar}>
                <Filter size={16} style={{ marginRight: "6px" }} />
                Filter
              </div>
              <div className={classes.iconbar}>
                <CalendarClock size={16} style={{ marginRight: "6px" }} />
                Schedule
              </div>
            </div>
            <div className={classes.iconbarss}>
              <div className={classes.iconbar}>
                <Mail size={16} />
              </div>
              <div className={classes.iconbar}>
                <Printer size={16} onClick={printInvoice} />
              </div>
              <div className={classes.iconbar}>
                <Download size={16} />
              </div>
              <div className={classes.iconbar}>
                <Settings size={16} />
              </div>
            </div>
          </div>
        </div>
        <div className={`${classes.matron} ${classes.noPrint}`}>
          <button className={classes.backButton} onClick={() => navigate(-1)}>
            <ArrowLeft size={16} style={{ marginRight: "6px" }} />
          </button>
        </div>

        <div
          id="invoice-print-root"
          ref={componentRef}
          className={`${classes.containere} ${classes.printable}`}
        >
          {/* New receipt design based on invoice template */}
          <div className={classes["invoice-box"]}>
            {/* Status badge – receipts are paid */}
            {/* <div
              className={`${classes["status-badge"]} ${isPaid ? classes.paid : classes.unpaid}`}
            >
              {isPaid ? "PAID" : "UNPAID"}
            </div> */}

            {/* Watermark */}
            <div className={classes.watermark}>
              {isPaid ? "PAID" : "UNPAID"}
            </div>

            {/* Header */}
            <div className={classes.header}>
              <div className={classes.company}>
                <img
                  src={company.logo || "/promix.png"}
                  alt={company.name || "Company Logo"}
                  className={classes.companyLogo}
                />
                <div>
                  <h2>{company.name || "—"}</h2>
                  <small>
                    {company.address || "—"}
                    <br />
                    {company.phone_number || "—"}
                    <br />
                    {company.email || "—"}
                  </small>
                </div>
              </div>

              <div className={classes["invoice-title"]}>
                <h1>RECEIPT</h1>
                <p>
                  Receipt No:{" "}
                  {responseData?.invoice_number || invoice?.invoice_number || "—"}
                  <br />
                  Date:{" "}
                  {responseData?.transaction_date ||
                    invoice?.transaction_date ||
                    "—"}
                  <br />
                  Due Date:{" "}
                  {responseData?.due_date || invoice?.due_date || "—"}
                </p>
              </div>
            </div>

            {/* Billing / customer info */}
            <table className={classes.info}>
              <tbody>
                <tr>
                  <td>
                    <strong>BILL TO</strong>
                    <br />
                    {responseData?.customer_id || invoice?.customer_id || "—"}
                    <br />
                    123 Business District Victoria Island, Lagos
                    <br />
                    +234 801 234 5678
                  </td>
                  <td>
                    <strong>Payment Terms</strong>
                    <br />
                    Due on receipt
                  </td>
                </tr>
              </tbody>
            </table>

            {/* Items */}
            <table className={classes.items}>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Description</th>
                  <th>Qty</th>
                  <th>Unit Price (₦)</th>
                  <th>Amount (₦)</th>
                </tr>
              </thead>
              <tbody>
                {(responseData?.sales || invoice?.sales || []).map(
                  (item, index) => {
                    const invoiceLevelDescription =
                      (responseData && responseData.description) ||
                      invoice?.description ||
                      responseData?.message ||
                      invoice?.message;

                    const lineDescription =
                      (invoiceLevelDescription && String(invoiceLevelDescription).trim()) ||
                      getBackendDescription(item, receiptDescription) ||
                      "—";

                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {lineDescription && lineDescription !== "—"
                            ? toTitleCase(lineDescription)
                            : lineDescription}
                        </td>
                      <td>{item?.quantity}</td>
                      <td>
                        {Number(item?.item?.price || 0).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )}
                      </td>
                      <td>
                        {Number(item?.amount || 0).toLocaleString(
                          undefined,
                          { minimumFractionDigits: 2 }
                        )}
                      </td>
                    </tr>
                    );
                  }
                )}
              </tbody>
            </table>

            {/* Totals */}
            <div className={classes.totals}>
              <table>
                <tbody>
                  <tr>
                    <td>Discount</td>
                    <td style={{textAlign:"right"}}>
                      {/* ₦ */}
                      {Number(
                        responseData?.total_discount ||
                        invoice?.total_discount ||
                        0
                      ).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td>Sub Total</td>
                    <td style={{textAlign:"right"}}>
                      {/* ₦ */}
                      {Number(
                        responseData?.sub_total || invoice?.sub_total || 0
                      ).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td>VAT (7.5%)</td>
                    <td style={{textAlign:"right"}}>
                      {/* ₦ */}
                      {Number(
                        responseData?.total_vat || invoice?.total_vat || 0
                      ).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td>WHT (0.02%)</td>
                    <td style={{textAlign:"right"}}>
                      {/* ₦ */}
                      {Number(
                        responseData?.total_wht || invoice?.total_wht || 0
                      ).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td style={{textAlign:"right"}}>
                      {/* ₦ */}
                      {Number(
                        responseData?.total_price ||
                        invoice?.total_price ||
                        0
                      ).toLocaleString("en-NG", {
                        minimumFractionDigits: 2,
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className={classes.clear}></div>

            {/* Payment details */}
            <div className={classes.section}>
              <strong>Payment Details</strong>
              <br />
              Bank: {company.bank_name || "—"}
              <br />
              Account Name: {company.account_name || company.name || "—"}
              <br />
              Account Number: {company.account_number || "—"}
            </div>

            {/* Notes */}
            <div className={classes.section}>
              <strong>Notes</strong>
              <br />
              This receipt acknowledges payment for the above services.
              <br />
              Thank you for your business.
            </div>

            {/* Signature */}
            <div className={classes.signature}>
              ___________________________
              <br />
              Authorized Signature
            </div>
          </div>
        </div>

      </div>
      <div className={classes.noPrint}>
        <Footer />
      </div>
    </div>
  );
};

export default PrintRecipt;
